import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { EuiSwitch } from "@elastic/eui";
import { StyledLabel, StyledRequired } from "components/styles";
import CheckBox from "components/checkbox";
import AccordionComponent from "components/accordion";
import TextArea from "components/textArea";
import UploadAttachments from "components/uploadAttachments";
import { FormGrid, FormRow, Row, StyledSubLabel } from "styles/forms/main";

const Container = styled.div`
    background-color: white;
`;

function QADetails({
    isEditable = true,
    attachements,
    setOperationalAttachments,
    isCreate,
    userRole,
    onDeleteUploadedItem,
    onDeleteAllAttachements,
    qADetails,
    setQaDetails,
    standardsAndProceduresList,
}) {
    const [hasOthers, setHasOthers] = useState(false);
    const ableToEdit =
        isCreate ||
        ((userRole === "sales_representative" || userRole === "project_manager") && isEditable);
    const showDocumentsAndPods =
        (ableToEdit && qADetails?.requireDocumentsCollection) || attachements?.length > 0;

    useEffect(() => {
        if (qADetails?.specialStandardsAndOperationalProcedures) {
            setHasOthers(true);
        }
    }, [qADetails]);

    const handleCheckboxChange = (event, field) => {
        const { checked, name } = event.target;

        setQaDetails((prevValues) => {
            if (checked) {
                return {
                    ...prevValues,
                    [field]: [...prevValues[field], name],
                };
            }
            return {
                ...prevValues,
                [field]: prevValues[field].filter((item) => item !== name),
            };
        });
    };

    return (
        <AccordionComponent
            id="QADetails"
            title={<h3>Operations QA details </h3>}
            zeroPadding
            body={
                <Container>
                    {ableToEdit && (
                        <FormRow>
                            <EuiSwitch
                                label="Project require documents collection?"
                                checked={qADetails?.requireDocumentsCollection}
                                onChange={(e) =>
                                    setQaDetails({
                                        ...qADetails,
                                        requireDocumentsCollection: e.target.checked,
                                    })
                                }
                            />
                        </FormRow>
                    )}
                    {qADetails?.requireDocumentsCollection && (
                        <FormRow>
                            <StyledLabel>
                                Select the needed documents to be collected{" "}
                                <StyledRequired>*</StyledRequired>
                            </StyledLabel>
                            <Row>
                                <CheckBox
                                    label="Good Receiving Note (GRNs)"
                                    name="hasGrnDocument"
                                    onChange={(e) => {
                                        setQaDetails({
                                            ...qADetails,
                                            hasGrnDocument: e.target.checked,
                                        });
                                    }}
                                    value={qADetails?.hasGrnDocument}
                                    borderd
                                    disabled={!ableToEdit}
                                />
                                <CheckBox
                                    label="Proof of Delivery (PODs)"
                                    name="hasPodDocument"
                                    onChange={(e) => {
                                        setQaDetails({
                                            ...qADetails,
                                            hasPodDocument: e.target.checked,
                                        });
                                    }}
                                    value={qADetails?.hasPodDocument}
                                    borderd
                                    disabled={!ableToEdit}
                                />
                            </Row>
                        </FormRow>
                    )}
                    {showDocumentsAndPods && (
                        <FormRow>
                            <UploadAttachments
                                onFilesChange={(files) => setOperationalAttachments(files)}
                                uploadedAttachments={attachements}
                                isEditable={
                                    isCreate ||
                                    ((userRole === "sales_representative" ||
                                        userRole === "project_manager") &&
                                        isEditable)
                                }
                                label="Operational Documents & PODs Samples"
                                onDeleteUploadedItem={onDeleteUploadedItem}
                                onDeleteAllAttachements={onDeleteAllAttachements}
                            />
                        </FormRow>
                    )}
                    <FormRow>
                        <EuiSwitch
                            label="Project requires ILLA’s on ground operators in the client premises"
                            checked={qADetails?.requiresIllaOperatorsInClientPremises}
                            onChange={(e) =>
                                setQaDetails({
                                    ...qADetails,
                                    requiresIllaOperatorsInClientPremises: e.target.checked,
                                })
                            }
                            disabled={!ableToEdit}
                        />
                    </FormRow>
                    {!isCreate &&
                        (userRole === "operations_specialist" ||
                            userRole === "project_manager" ||
                            qADetails?.operationsSiteVisitDetails) && (
                            <FormRow>
                                <TextArea
                                    required={false}
                                    isEditable={
                                        (userRole === "operations_specialist" ||
                                            userRole === "project_manager") &&
                                        isEditable
                                    }
                                    type="text"
                                    name="siteVisitDetails"
                                    label="Site visit Operational details"
                                    placeholder=""
                                    onChange={(e) => {
                                        setQaDetails(
                                            "operationsSiteVisitDetails",
                                            e?.target?.value
                                        );
                                    }}
                                    value={qADetails?.operationsSiteVisitDetails}
                                />
                            </FormRow>
                        )}
                    <FormRow>
                        <StyledLabel>Client Standards & operational procedures </StyledLabel>
                    </FormRow>
                    <FormRow>
                        {/* <StyledSubLabel>The driver must wear </StyledSubLabel> */}
                        <FormGrid>
                            {standardsAndProceduresList?.map((item) => (
                                <CheckBox
                                    label={item.label}
                                    name={item.value}
                                    borderd
                                    onChange={(e) =>
                                        handleCheckboxChange(e, "standardsAndOperationalProcedures")
                                    }
                                    value={qADetails?.standardsAndOperationalProcedures?.includes(
                                        item.value
                                    )}
                                    disabled={!ableToEdit}
                                />
                            ))}
                        </FormGrid>
                    </FormRow>
                    <FormRow>
                        <StyledSubLabel>Others</StyledSubLabel>
                        <Row>
                            <CheckBox
                                label="Others"
                                name="isOthers"
                                value={hasOthers}
                                onChange={(e) => {
                                    setHasOthers(e.target.checked);
                                    setQaDetails({
                                        ...qADetails,
                                        specialStandardsAndOperationalProcedures: e.target.checked,
                                    });
                                }}
                                borderd
                                disabled={!ableToEdit}
                            />
                            {hasOthers && (
                                <TextArea
                                    required
                                    isEditable={ableToEdit}
                                    type="text"
                                    name="specialStandardsAndOperationalProcedures"
                                    label="Others"
                                    placeholder=""
                                    onChange={(e) =>
                                        setQaDetails({
                                            ...qADetails,
                                            specialStandardsAndOperationalProcedures:
                                                e.target.value,
                                        })
                                    }
                                    value={qADetails?.specialStandardsAndOperationalProcedures}
                                />
                            )}
                        </Row>
                    </FormRow>
                </Container>
            }
            defaultExpanded
        />
    );
}

export default QADetails;
